module.exports = "/_next/static/images/higher-retention-6d76289832bc4b15724bfef0c2b7502f.svg";